import './UpdateNavbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faPenToSquare, faPen, faUser, faBook,faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';

function UpdateNavbar({ logout }) {
    return (
        <>
            <div className='update-navbar'>
                <div className='admin'>
                    <img />
                    <h>Admin</h>
                </div>
                <ul className='update-choice' >
                    <CustomLink to='/login'><FontAwesomeIcon icon={faHouse} className='icon' /><text>อัปเดทข่าวประชาสัมพันธ์</text></CustomLink>
                    <CustomLink to='/login/updateactivity'><FontAwesomeIcon icon={faPenToSquare} className='icon' /><text> อัปเดตกิจกรรม</text></CustomLink>
                    <CustomLink to='/login/updateadministrator'><FontAwesomeIcon icon={faUser} className='icon' /><text> อัปเดตผู้บริหาร</text></CustomLink>
                    <CustomLink to='/login/managestaff'><FontAwesomeIcon icon={faBook} className='icon' /><text> อัปเดตกลุ่มสาระ</text></CustomLink>
                </ul>
                <div className='logout'>
                    <button onClick={logout}><FontAwesomeIcon icon={faRightFromBracket} className='icon' /><text>Log Out</text></button>
                </div>
            </div>
        </>
    );
}

export default UpdateNavbar

function CustomLink({ to, children, ...props }) {
    const resolvePath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvePath.pathname, end: true })
    return (
        <Link to={to} {...props}><li><div className={isActive ? "active" : ""}></div>{children}</li></Link>
    )
}